function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.99,
    y: 147.57,
    width: 314.02,
    height: 424.85,
    rx: 1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.4,
    y: 202.99,
    width: 203.19,
    height: 73.89,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.35,
    y1: 332.29,
    x2: 295.35,
    y2: 406.18,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.29,
    y1: 369.24,
    x2: 258.4,
    y2: 369.24,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.18,
    y1: 498.54,
    x2: 461.6,
    y2: 498.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.12,
    y1: 369.24,
    x2: 276.88,
    y2: 498.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.1815f52e6329a9d6172de699f9b5e4c4.svg";
export { ForwardRef as ReactComponent };